module.exports = __webpack_require__.p + "2a7f7cb9097bfacb8c1dbb5a4909e3c6.jpg";